export default "https://cdn-static.gokick.com/assets/b944ecdade3ab4b24738bd1fcec1eea00d00fb75/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";